<script setup lang="ts">
import DefaultModalBase from "../DefaultModalBase.vue";
import {reactive, computed, ref} from "vue";
import { useUserStore } from "../../../store/users"
import { useModalStore } from "../../../store/modal"

const error = ref(null)
const loading = ref(false)
const user_created = ref(false)
const userStore = useUserStore()
const modalStore = useModalStore()
const options = userStore.roles
const user = reactive({
    role: null,
    first_name: null,
    last_name: null,
    email: null,
    contact_number: null,
})

const disabled = computed(() => {
  return Object.values(user).some(value => value === null || value === "");
});

const createUser = async () => {
    error.value = null
    loading.value = true
    try {
        await userStore.addUser(user)
        user_created.value = true
    }
    catch (err) {
        error.value = err.response.data.message ?? "Something went wrong. Please try again."
    } finally {
        loading.value = false
    }
}

const icon = computed(() => !user_created.value ? 'user-single-add' : 'check-single')
const heading = computed(() => !user_created.value ? 'Create a new user.' : `${userStore.user?.first_name} ${userStore.user?.last_name} created.`)
</script>

<template>
    <default-modal-base :heading :icon :loading :refresh="user_created" :error>
        <div class="user-add-modal-container" v-if="!user_created">
            <brand-form-select label="Role." :options v-model="user.role" />
            <brand-form-input label="First Name." v-model="user.first_name" />
            <brand-form-input label="Last Name." v-model="user.last_name" />
            <brand-form-input label="Email." v-model="user.email" type="email"/>
            <brand-form-input label="Cellphone." v-model="user.contact_number" type="tel"/>
            <brand-button :disabled @click.prevent="createUser()">Create user</brand-button>
        </div>

        <brand-button variant="secondary" v-else @click.prevent="modalStore.close()">Done</brand-button>
    </default-modal-base>
</template>

<style scoped lang="scss">
.user-add-modal-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    .brand-button {
        margin-top: 2rem;
    }
}

.brand-button {
    width: 100%;
}
</style>
